import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as PresenceReportActions from '~/repositories/presence-report/store/presence-report.actions';
import { PresenceReportGroupEntity } from '~/repositories/presence-report/store/presence-report.models';

export interface PresenceReportState extends EntityState<PresenceReportGroupEntity> {
  loaded?: boolean;
  error?: string | null;
}

export const presenceReportAdapter: EntityAdapter<PresenceReportGroupEntity> =
  createEntityAdapter<PresenceReportGroupEntity>();
export const initialPresenceReportState: PresenceReportState = presenceReportAdapter.getInitialState({
  loaded: false
});

const reducer = createReducer(
  initialPresenceReportState,
  on(PresenceReportActions.fetchOrgans, (state) => ({
    ...state,
    loaded: false,
    error: null
  })),
  on(PresenceReportActions.fetchOrgansSuccess, (state, { organs }) =>
    presenceReportAdapter.setAll(organs, {
      ...state,
      loaded: true
    })
  ),
  on(PresenceReportActions.fetchOrgansFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(PresenceReportActions.publishPresenceReportDetails, (state) => ({
    ...state,
    loaded: false,
    error: null
  })),
  on(PresenceReportActions.publishPresenceReportDetailsSuccess, (state) => ({
    ...state,
    loaded: true
  })),
  on(PresenceReportActions.publishPresenceReportDetailsFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export function presenceReportReducer(state: PresenceReportState, action: Action) {
  return reducer(state, action);
}
